import { EMPTY_STR } from "@/constants/string";

export const formatLearningHours = (seconds: number | null): string => {
  if (seconds == null) return EMPTY_STR.TEXT;
  const hours = seconds / 3600;
  return `${hours.toFixed(1)} h`;
};

export const formatMockExamScore = (score: number | null): string => {
  if (score == null) return EMPTY_STR.TEXT;
  return `${score}点`;
};

export const formatProgressPercent = (percent: number | null): string => {
  if (percent == null) return EMPTY_STR.TEXT;
  return `${percent}%`;
};
